import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, extractTime, formateDate } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
// import $ from "jquery";
import Breadcrums from "../../common/breadcrumbs";
import { Details } from "../../services/doctor.services";
import { ROLE } from "../../../../utils/Constants";
import { getAppointments } from "../../../doctor/services/patient.services";
import { param } from "jquery";

const AppointmentView = (props) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const params = useParams();
    const [showdefault, setShowDefault] = useState({});

    const breadcrumbs = [
        { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
        {
            title: 'Appointment',
            url: "/admin/appointment/list/1",
        },
        { title: t("admin.cafes.link_view"), url: "" },
    ];


    useEffect(() => {
        const formData = new FormData()
        formData.append("appointment_id", params?.id)
        getAppointments(formData,ROLE.SUPER_ADMIN)
            .then((response) => {
                setShowDefault(response && response.data ? response.data : []);
            })
            .catch((error) => {
                console.log("error=====>", error);
            });
    }, [params.id]);

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">
                        <div className="card-body">
                            {showdefault && Object.keys(showdefault).length > 0 ? <div className='row'>
                                <div className="col-lg-12 form-group">
                                    <table id="simple-table" className="table  table-bordered table-hover">
                                        <tbody>
                                        <tr>
                                                <th> {t("Appointment ID")}</th>
                                                <td className="text-capitalize">
                                                    #{showdefault && showdefault.appointment_register_id
                                                        ? showdefault.appointment_register_id
                                                        : "N/A"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th> {t("Doctor ID")}</th>
                                                <td className="text-capitalize">
                                                    #{showdefault && showdefault.doctor_register_id
                                                        ? showdefault.doctor_register_id
                                                        : "N/A"}
                                                </td>
                                            </tr>

                                            <tr>
                                                <th>{t("Doctor Name")}</th>
                                                <td className="text-capitalize">
                                                    {showdefault && showdefault.doctor_name ? capitalizeFirstLetter(showdefault.doctor_name) : "N/A"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th> {t("Patient ID")}</th>
                                                <td className="text-capitalize">
                                                    #{showdefault && showdefault.patient_register_id
                                                        ? showdefault.patient_register_id
                                                        : "N/A"}
                                                </td>
                                            </tr>

                                            <tr>
                                                <th>{t("Patient Name")}</th>
                                                <td className="text-capitalize">
                                                    {showdefault && showdefault.patient_name ? capitalizeFirstLetter(showdefault.patient_name) : "N/A"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>{t("Patient Phone Number")}</th>
                                                <td className="text-capitalize">
                                                    {showdefault && showdefault.patient_phone_no ? (showdefault.patient_phone_no) : "N/A"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>{t("Appointment Date")}</th>
                                                <td>
                                                    {showdefault && showdefault.appointment_date
                                                        ? formateDate(showdefault.appointment_date)
                                                        : "N/A"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>{t("Appointment Zone")}</th>
                                                <td>
                                                    {showdefault && showdefault.appointment_zone
                                                        ? capitalizeFirstLetter(showdefault.appointment_zone)
                                                        : "N/A"}
                                                </td>
                                            </tr>
                                            {/* <tr>
                                                <th>{t("Start Time")}</th>
                                                <td>
                                                    {showdefault && showdefault.start_time
                                                        ? showdefault.start_time
                                                        : "N/A"}
                                                </td>
                                            </tr> */}
                                             <tr>
                                                <th>{t("Start Time")}</th>
                                                <td>
                                                    {showdefault && showdefault.appointment_date
                                                        ? extractTime(showdefault.appointment_date)
                                                        : "N/A"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>{t("Major Concern")}</th>
                                                <td>
                                                    {showdefault && showdefault.major_concern
                                                        ? capitalizeFirstLetter(showdefault.major_concern)
                                                        : "N/A"}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div className="mt-5">
                                        <button className="btn ripple btn-dark" type='button' onClick={() => navigate(-1)}>
                                            <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                                            {t("admin.button.btn_back")}
                                        </button>
                                    </div>
                                </div>
                            </div> : <Loader />}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AppointmentView;
